/** @return {import('vue').ComponentOptions} */
export const useRender = () => ({
    props: {
        /** @type {import('vue').PropOptions<import('../../constants').ITool>}*/
        tool: {
            type: Object,
            default: null
        }
    },
    computed: {
        /** @return {string} */
        icon() {
            const { tool } = this;
            
            if (tool == null) {
                return 'mdi-help-box';
            }
    
            return [null, undefined, ''].includes(tool.icon) ? 'mdi-help-box' : `mdi-${tool.icon}`;
        },
        /** @return {string} */
        title() {
            const { tool } = this;
    
            if (tool == null) {
                return 'Unknown tool';
            }
            
            return tool.title ?? tool.name ?? 'Unknown tool';
        },
        /** @return {boolean} */
        isActive() {
            return this.tool.isActive();
        },
        /** @return {boolean} */
        isEnabled() {
            return this.tool.isEnabled();
        }
    },
    methods: {
        /** to notify the wysiwyg-editor that a command was executed */
        emitExecuted() {
            this.$emit('command-executed');
        }
    }
});

export const RenderMixinTypes = undefined;
